import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NewCallListModal from 'components/modals/new_call_list_modal';

import { endNewCallList } from '../../store/actions/companies';
import { createCallListWithTasks } from '../../store/actions/call_lists';
import { getDatabaseMembers, getShowNewCallListModal } from '../../store/selectors/companies';
import { getCompaniesById } from '../../store/selectors/search';
import { getSelectedCompanyIds } from '../../store/selectors/select_list';
import { getAvailableDatabases, getCurrentUser } from '../../store/selectors/static';

export class CompaniesNewCallListModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    companies: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    selectedCompanyIds: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    onCancelNewCallList: PropTypes.func.isRequired,
    onCreateCallList: PropTypes.func.isRequired
  };

  handleCreateCallList = (data) => {
    const { selectedCompanyIds, onCancelNewCallList, onCreateCallList } = this.props;
    onCreateCallList(data, selectedCompanyIds.map(id => [id, "Contacts::Company"]));
    onCancelNewCallList();
  }

  render() {
    const {
      availableDatabases,
      currentUser,
      selectedCompanyIds,
      companies,
      showModal,
      databaseMembers,
      onCancelNewCallList
    } = this.props;

    const selectedContacts = [];
    selectedCompanyIds.forEach((id) => {
      const company = companies[id] || { id: id, unloaded: true };
      selectedContacts.push(company);
    });

    const defaultAssociatedModels = [
      {
        associatedModelId: 1,
        associatedModelType: "Multiple",
        name: "Multiple Contacts",
        default: true
      }
    ];

    return (
      <NewCallListModal
        availableDatabases={availableDatabases}
        currentUser={currentUser}
        databaseMembers={databaseMembers}
        defaultAssociatedModels={defaultAssociatedModels}
        selectedContacts={selectedContacts}
        shown={showModal}
        onCancel={onCancelNewCallList}
        onSubmit={this.handleCreateCallList}
      />
    );
  }
}

const mapStateToProps = state => ({
  availableDatabases: getAvailableDatabases(state),
  currentUser: getCurrentUser(state),
  databaseMembers: getDatabaseMembers(state),
  companies: getCompaniesById(state),
  selectedCompanyIds: getSelectedCompanyIds(state),
  showModal: getShowNewCallListModal(state)
});

const mapDispatchToProps = {
  onCancelNewCallList: endNewCallList,
  onCreateCallList: createCallListWithTasks,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesNewCallListModal);
